var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { actionGameTrackingShopBackToOffers, actionGameTrackingShopPackageSelect, actionGameTrackingShopPackageShow, } from "../../game-tracking/shop/actionGameTrackingShop";
import { ModalButtonClose } from "../../generic/common/ModalButtonClose";
import { Slideshow } from "../../generic/slideshow/Slideshow";
import { actionShopSelectOffer } from "../actionShop";
import { Offer } from "./Offer";
import { OfferPageGrowingReward } from "./OfferPageGrowingReward";
import { OfferPageHC } from "./OfferPageHC";
import { ShopPaymentPage } from "./ShopPaymentPage";
var ShopDOM = /** @class */ (function (_super) {
    __extends(ShopDOM, _super);
    function ShopDOM() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selectedOffer: undefined,
        };
        _this.getChildrenElement = function () {
            var selectedOffer = _this.state.selectedOffer;
            var children = _this.props.children;
            var isOfferSelected = selectedOffer != undefined;
            return isOfferSelected ? undefined : children;
        };
        _this.getCloseButton = function () {
            var onClose = _this.props.onClose;
            return React.createElement(ModalButtonClose, { onClick: onClose, className: "offer-header__close-btn" });
        };
        _this.getPaymentProviderSelection = function () {
            var selectedOffer = _this.state.selectedOffer;
            var className = selectedOffer != undefined ? "show" : "";
            return (React.createElement("div", { className: "shop-psp-container " + className },
                React.createElement(ShopPaymentPage, { offer: selectedOffer, onReturn: _this.onOfferDeselected })));
        };
        _this.handlePageChange = function (page) {
            _this.trackShowOffer(page);
        };
        _this.getOffersSlideshow = function () {
            var selectedPage = _this.props.selectedPage;
            var selectedOffer = _this.state.selectedOffer;
            var slideshowClass = selectedOffer != undefined ? "hide-slideshow" : "";
            var allOffers = _this.allOffers();
            var showPageIndicators = allOffers.length > 1;
            return (React.createElement(Slideshow, { onPageChange: _this.handlePageChange, pages: allOffers, page: selectedPage, className: slideshowClass, showIndicators: showPageIndicators }));
        };
        _this.trackShowOffer = function (page) {
            var _a = _this.props, offers = _a.offers, offerBundles = _a.offerBundles, offerBundleGrowthFund = _a.offerBundleGrowthFund, onOfferShow = _a.onOfferShow;
            if (onOfferShow == undefined) {
                return;
            }
            if (page < offers.length && offers[page] != undefined) {
                onOfferShow({
                    offer: offers[page],
                    page: page,
                });
            }
            else if (page >= offers.length && page < offers.length + offerBundleGrowthFund.length) {
                onOfferShow({ offer: offerBundleGrowthFund[page - offers.length], page: page });
            }
            else {
                var offerBundle = offerBundles[page - offers.length - offerBundleGrowthFund.length] || [];
                offerBundle.forEach(function (value, index) {
                    return setTimeout(function () {
                        onOfferShow({ offer: value, page: page });
                    }, index * 100);
                });
            }
        };
        _this.onOfferSelected = function (offer) {
            var _a = _this.props, offers = _a.offers, offerBundles = _a.offerBundles, offerBundleGrowthFund = _a.offerBundleGrowthFund, onOfferSelect = _a.onOfferSelect;
            var allOffers = (offerBundles || []).concat([(offerBundleGrowthFund || []).slice()]).reduce(function (acc, val) { return acc.concat(val); }, offers);
            var selectedOffer = allOffers.find(function (val) {
                return (val.purchaseOfferNameId === offer.purchaseOfferNameId &&
                    val.offerCharacteristicId === offer.offerCharacteristicId);
            });
            if (selectedOffer == undefined) {
                return;
            }
            if (onOfferSelect) {
                onOfferSelect(selectedOffer.purchaseOfferNameId);
            }
            _this.setState({
                selectedOffer: __assign({}, selectedOffer, { onCloseClick: _this.onOfferDeselected }),
            });
        };
        _this.onOfferDeselected = function () {
            var onOfferDeselect = _this.props.onOfferDeselect;
            _this.setState({
                selectedOffer: undefined,
            });
            if (onOfferDeselect) {
                onOfferDeselect();
            }
        };
        _this.renderOffer = function () {
            var offers = _this.props.offers;
            return offers.map(function (offer) { return React.createElement(Offer, __assign({}, offer, { onBuyClick: _this.onOfferSelected })); });
        };
        _this.renderOfferBundle = function () {
            var offerBundles = _this.props.offerBundles;
            if (offerBundles == undefined) {
                return [];
            }
            return offerBundles.map(function (offerBundle) {
                var offers = offerBundle.map(function (offer) { return (__assign({}, offer, { onBuyClick: _this.onOfferSelected })); });
                return React.createElement(OfferPageHC, { offers: offers });
            });
        };
        _this.renderOfferGrowthFund = function () {
            var offerBundleGrowthFund = _this.props.offerBundleGrowthFund;
            if (offerBundleGrowthFund == undefined) {
                return [];
            }
            return offerBundleGrowthFund.map(function (offer) {
                var offers = __assign({}, offer, { onBuyClick: _this.onOfferSelected });
                return React.createElement(OfferPageGrowingReward, { offer: offers });
            });
        };
        _this.allOffers = function () {
            return _this.renderOffer().concat(_this.renderOfferGrowthFund(), _this.renderOfferBundle());
        };
        return _this;
    }
    ShopDOM.prototype.render = function () {
        var offersSlideshow = this.getOffersSlideshow();
        var paymentProviderSelection = this.getPaymentProviderSelection();
        var closeButton = this.getCloseButton();
        var shopChildren = this.getChildrenElement();
        return (React.createElement("div", { className: "shop-container" },
            offersSlideshow,
            paymentProviderSelection,
            closeButton,
            shopChildren));
    };
    ShopDOM.prototype.componentDidMount = function () {
        this.trackShowOffer(this.props.selectedPage || 0);
    };
    return ShopDOM;
}(React.PureComponent));
var mapDispatch = function (dispatch) { return ({
    onOfferDeselect: function () { return dispatch(actionGameTrackingShopBackToOffers()); },
    onOfferSelect: function (offerNameId) {
        dispatch(actionGameTrackingShopPackageSelect(offerNameId));
    },
    onOfferShow: function (selectedOfferInfo) {
        dispatch(actionShopSelectOffer(selectedOfferInfo));
        dispatch(actionGameTrackingShopPackageShow(selectedOfferInfo.offer.purchaseOfferNameId));
    },
}); };
export var Shop = connect(undefined, mapDispatch)(ShopDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/Shop.tsx
// module id = 957
// module chunks = 3